export const trimLeadChar = (str: string) => {
  // Remove all leading non-alphanumeric characters
  return str.replace(/^[^\dA-Za-z]+/u, "");
};
